<template>
  <!-- 经营信息 -->
  <div>
    <div id="management-information" v-if="enterpriseInfo.base">
      <div class="management-information-type">
        <!-- 招投标 -->
        <div class="management-information-item" id="招投标">
          <div class="management-information-item-title">
            招投标 ({{ ZTBInformation.pageData.totalCount }})
          </div>
          <div class="management-information-item-value">
            <enterpriseTable
              :table="ZTBInformation"
              @handleCurrentChange="handleCurrentChange"
            />
          </div>
        </div>
        <!-- 招聘概况 -->
        <div class="management-information-item" id="招聘概况">
          <div class="management-information-item-title">招聘概况</div>
          <div class="management-information-item-value">
            <enterpriseTableText :table="inviteInformation" />
          </div>
        </div>
        <!-- 招聘岗位 -->
        <div class="management-information-item" id="招聘岗位">
          <div class="management-information-item-title">
            招聘岗位 ({{ invitePosition.pageData.totalCount }})
          </div>
          <div class="management-information-item-value">
            <enterpriseCard5
              :table="invitePosition"
              @handleCurrentChange="handleCurrentChange"
            />
          </div>
        </div>
        <!-- 新媒体账号 -->
        <div class="management-information-item" id="新媒体账号">
          <div class="management-information-item-title">
            新媒体账号 ({{ newMediaAccount.pageData.totalCount }})
            <div class="management-information-item-title-search">
              <div class="search-item">
                <el-select
                  v-model="newMediaAccount.searchData.accountType"
                  placeholder="请选择账号类型"
                  @change="getNewMediaAccount"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in newMediaAccount.searchData
                      .accountTypeList"
                    :key="index"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="management-information-item-value">
            <enterpriseTable
              :table="newMediaAccount"
              @handleCurrentChange="handleCurrentChange"
            />
          </div>
        </div>
        <!-- 网店 -->
        <div class="management-information-item" id="网店">
          <div class="management-information-item-title">
            网店 ({{ onlineStoreInformation.pageData.totalCount }})
            <div class="management-information-item-title-search">
              <div class="search-item">
                <el-select
                  v-model="onlineStoreInformation.searchData.type"
                  placeholder="请选择网店类型"
                  @change="getOnlineStoreInformation"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in onlineStoreInformation.searchData
                      .typeList"
                    :key="index"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="management-information-item-value">
            <enterpriseCard6
              :table="onlineStoreInformation"
              @handleCurrentChange="handleCurrentChange"
            />
          </div>
        </div>
        <!-- 纳税资质 -->
        <div class="management-information-item" id="纳税资质">
          <div class="management-information-item-title">
            纳税资质 ({{ taxQualification.pageData.totalCount }})
          </div>
          <div class="management-information-item-value">
            <enterpriseTable
              :table="taxQualification"
              @handleCurrentChange="handleCurrentChange"
            />
          </div>
        </div>
        <!-- 纳税信用 -->
        <div class="management-information-item" id="纳税信用">
          <div class="management-information-item-title">
            纳税信用 ({{ taxCredit.pageData.totalCount }})
          </div>
          <div class="management-information-item-value">
            <enterpriseTable
              :table="taxCredit"
              @handleCurrentChange="handleCurrentChange"
            />
          </div>
        </div>
        <!-- 进出口信用 -->
        <div class="management-information-item" id="进出口信用">
          <div class="management-information-item-title">
            进出口信用 ({{ importAndExportInformation.pageData.totalCount }})
          </div>
          <div class="management-information-item-value">
            <enterpriseTable
              :table="importAndExportInformation"
              @handleCurrentChange="handleCurrentChange"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <el-empty description="暂无数据"></el-empty>
    </div>
  </div>
</template>

<script>
import * as allClientData from "@/views/client/js/clientData.js";
import enterpriseTable from "@/components/enterprise-components/enterprise-table";
import enterpriseTableText from "@/components/enterprise-components/enterprise-table-text";
import enterpriseCard5 from "@/components/enterprise-components/enterprise-card5";
import enterpriseCard6 from "@/components/enterprise-components/enterprise-card6";
import { callWithDelay } from "@/minixs.js";
export default {
  components: {
    enterpriseTable,
    enterpriseTableText,
    enterpriseCard5,
    enterpriseCard6,
  },
  props: {
    clientInfo: {
      type: Object,
      default: () => {},
    },
    tabActive: {
      type: Object,
      default: () => {},
    },
    enterpriseInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      ZTBInformation: {
        type: "ZTBInformation",
        tableMenu: [
          {
            label: "项目名称",
            width: "",
            prop: "title",
            type: "link",
          },
          {
            label: "项目地区",
            width: "",
            prop: "region",
          },
          {
            label: "发布日期",
            width: "",
            prop: "noticeTime",
          },
          {
            label: "信息类型",
            width: "",
            prop: "typeStr",
          },
          {
            label: "采购单位",
            width: "",
            prop: "purchaseName",
          },
          {
            label: "中标单位",
            width: "",
            prop: "zbdw",
          },
          {
            label: "中标金额",
            width: "",
            prop: "zbAmount",
          },
        ],
        tableData: [],
        pageData: {
          pageIndex: 1,
          pageSize: 10,
          totalCount: 0,
        },
      }, // 招投标
      inviteInformation: allClientData.companyInfoByTableText("招聘概况"), // 招聘概况
      invitePosition: {
        type: "invitePosition",
        tableData: [],
        pageData: {
          pageIndex: 1,
          pageSize: 6,
          totalCount: 0,
        },
      }, // 招聘岗位
      newMediaAccount: {
        type: "newMediaAccount",
        searchData: {
          accountType: "",
          accountTypeList: [],
        },
        tableMenu: [
          {
            label: "账号名称",
            width: "",
            prop: "accountName",
            type: "logo_link",
          },
          {
            label: "类型",
            width: "",
            prop: "type",
          },
          {
            label: "简介",
            width: "",
            prop: "description",
          },
          {
            label: "账号ID",
            width: "",
            prop: "accountId",
          },
        ],
        tableData: [],
        pageData: {
          pageIndex: 1,
          pageSize: 10,
          totalCount: 0,
        },
      }, // 新媒体账号
      onlineStoreInformation: {
        type: "onlineStoreInformation",
        searchData: {
          type: "",
          typeList: [],
        },
        tableData: [],
        pageData: {
          pageIndex: 1,
          pageSize: 6,
          totalCount: 0,
        },
      }, // 网店
      taxQualification: {
        type: "taxQualification",
        tableMenu: [
          {
            label: "纳税人识别号",
            width: "",
            prop: "scid",
          },
          {
            label: "纳税人资格类型",
            width: "",
            prop: "taxpayerType",
          },
          {
            label: "登记日期",
            width: "",
            prop: "registrationDate",
          },
          {
            label: "有效期至",
            width: "",
            prop: "validityDate",
          },
          {
            label: "所属地区",
            width: "",
            prop: "province",
          },
        ],
        tableData: [],
        pageData: {
          pageIndex: 1,
          pageSize: 10,
          totalCount: 0,
        },
      }, // 纳税资质
      taxCredit: {
        type: "taxCredit",
        tableMenu: [
          {
            label: "评价年度",
            width: "",
            prop: "year",
          },
          {
            label: "纳税人识别号",
            width: "",
            prop: "tin",
          },
          {
            label: "纳税人信用等级",
            width: "",
            prop: "level",
          },
          {
            label: "主管税务机关",
            width: "",
            prop: "authorityInCharge",
          },
          {
            label: "所属地区",
            width: "",
            prop: "province",
          },
        ],
        tableData: [],
        pageData: {
          pageIndex: 1,
          pageSize: 2,
          totalCount: 0,
        },
      }, // 纳税信用
      importAndExportInformation: {
        type: "importAndExportInformation",
        tableMenu: [
          {
            label: "注册海关",
            width: "",
            prop: "customsregistration",
          },
          {
            label: "经营类别",
            width: "",
            prop: "tradetypename",
          },
          {
            label: "跨境电子商务企业类型",
            width: "",
            prop: "crossbordertradeflags",
          },
          {
            label: "信用等级",
            width: "",
            prop: "creditrating",
          },
          {
            label: "直属海关",
            width: "",
            prop: "directlycustoms",
          },
        ],
        tableData: [],
        pageData: {
          pageIndex: 1,
          pageSize: 2,
          totalCount: 0,
        },
      }, // 进出口信用
    };
  },
  mixins: [callWithDelay],
  watch: {
    "tabActive.tab2Active": {
      handler(newValue, oldValue) {
        // tabActive.tab3Active 变化时 页面滑动到对应区域
        this.$nextTick(() => {
          document
            .getElementById(newValue)
            .scrollIntoView({ behavior: "smooth" });
        });
      },
    },
  },
  methods: {
    // 招投标
    getZTBInformation() {
      let requestData = {
        eid: this.enterpriseInfo.base.eid,
        pageIndex: this.ZTBInformation.pageData.pageIndex,
        pageSize: this.ZTBInformation.pageData.pageSize,
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_1530",
        requestData,
        (data) => {
          this.ZTBInformation.tableData = data.yunyangData.zTB.data;

          this.ZTBInformation.pageData = {
            pageIndex: data.yunyangData.zTB.pageIndex,
            pageSize: data.yunyangData.zTB.pageSize,
            totalCount: data.yunyangData.zTB.totalCount,
          };
          this.$emit("changeActiveCount", {
            tab2Active: "招投标",
            tab3Active: "",
            count: this.ZTBInformation.pageData.totalCount,
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 招聘概况
    getInviteInformation() {
      this.$request(
        "get",
        "/xiaoLanBen/api_4793?eid=" + this.enterpriseInfo.base.eid,
        {},
        (data) => {
          if (data.entInfo.zhaopinAgg3m) {
            this.inviteInformation.forEach((item) => {
              item.value = data.entInfo.zhaopinAgg3m[item.key];
            });
          }
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 招聘岗位
    getInvitePosition() {
      let requestData = {
        keyword: "", // 搜索关键字
        eid: this.enterpriseInfo.base.eid,
        pageIndex: this.invitePosition.pageData.pageIndex,
        pageSize: this.invitePosition.pageData.pageSize,
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_4798",
        requestData,
        (data) => {
          this.invitePosition.tableData = data.entInfo.pagerZhaopin.data;

          this.invitePosition.pageData = {
            pageIndex: data.entInfo.pagerZhaopin.pageIndex,
            pageSize: data.entInfo.pagerZhaopin.pageSize,
            totalCount: data.entInfo.pagerZhaopin.totalCount,
          };
          this.$emit("changeActiveCount", {
            tab2Active: "招聘岗位",
            tab3Active: "",
            count: this.invitePosition.pageData.totalCount,
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 新媒体账号
    getNewMediaAccount() {
      let requestData = {
        accountType: this.newMediaAccount.searchData.accountType, // 账号类型空为全部；weibo/xcx/wechat/toutiao/douyin/kuaishou
        eid: this.enterpriseInfo.base.eid,
        pageIndex: this.newMediaAccount.pageData.pageIndex,
        pageSize: this.newMediaAccount.pageData.pageSize,
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_4707",
        requestData,
        (data) => {
          this.newMediaAccount.tableData =
            data.entInfo.pagerNewMediaByType.data;
          this.newMediaAccount.tableData.forEach((item) => {
            if (item.accountType == "wechat") {
              item.type = "微信公众号";
            }
            if (item.accountType == "weibo") {
              item.type = "官方微博";
            }
            if (item.accountType == "xcx") {
              item.type = "微信小程序";
            }
          });
          this.newMediaAccount.searchData.accountTypeList =
            data.entInfo.pagerNewMediaByType.extData.accountTypeList;
          this.newMediaAccount.pageData = {
            pageIndex: data.entInfo.pagerNewMediaByType.pageIndex,
            pageSize: data.entInfo.pagerNewMediaByType.pageSize,
            totalCount: data.entInfo.pagerNewMediaByType.totalCount,
          };
          this.$emit("changeActiveCount", {
            tab2Active: "新媒体账号",
            tab3Active: "",
            count: this.newMediaAccount.pageData.totalCount,
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 网店
    getOnlineStoreInformation() {
      let requestData = {
        type: this.onlineStoreInformation.searchData.type, // 类型；空为全部
        eid: this.enterpriseInfo.base.eid,
        pageIndex: this.onlineStoreInformation.pageData.pageIndex,
        pageSize: this.onlineStoreInformation.pageData.pageSize,
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_3521",
        requestData,
        (data) => {
          this.onlineStoreInformation.tableData = data.entInfo.pagerShop.data;

          this.onlineStoreInformation.searchData.typeList =
            data.entInfo.pagerShop.extData.typeList;

          this.onlineStoreInformation.pageData = {
            pageIndex: data.entInfo.pagerShop.pageIndex,
            pageSize: data.entInfo.pagerShop.pageSize,
            totalCount: data.entInfo.pagerShop.totalCount,
          };
          this.$emit("changeActiveCount", {
            tab2Active: "网店",
            tab3Active: "",
            count: this.onlineStoreInformation.pageData.totalCount,
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 纳税资质
    getTaxQualification() {
      let requestData = {
        eid: this.enterpriseInfo.base.eid,
        pageIndex: this.taxQualification.pageData.pageIndex,
        pageSize: this.taxQualification.pageData.pageSize,
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_4766",
        requestData,
        (data) => {
          this.taxQualification.tableData = data.entInfo.pagerTaxpayer.data;

          this.taxQualification.pageData = {
            pageIndex: data.entInfo.pagerTaxpayer.pageIndex,
            pageSize: data.entInfo.pagerTaxpayer.pageSize,
            totalCount: data.entInfo.pagerTaxpayer.totalCount,
          };
          this.$emit("changeActiveCount", {
            tab2Active: "纳税资质",
            tab3Active: "",
            count: this.taxQualification.pageData.totalCount,
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 纳税信用
    getTaxCredit() {
      let requestData = {
        eid: this.enterpriseInfo.base.eid,
        pageIndex: this.taxCredit.pageData.pageIndex,
        pageSize: this.taxCredit.pageData.pageSize,
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_4767",
        requestData,
        (data) => {
          this.taxCredit.tableData = data.entInfo.pagerTaxpayerASwj.data;

          this.taxCredit.pageData = {
            pageIndex: data.entInfo.pagerTaxpayerASwj.pageIndex,
            pageSize: data.entInfo.pagerTaxpayerASwj.pageSize,
            totalCount: data.entInfo.pagerTaxpayerASwj.totalCount,
          };
          this.$emit("changeActiveCount", {
            tab2Active: "纳税信用",
            tab3Active: "",
            count: this.taxCredit.pageData.totalCount,
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 进出口信用
    getImportAndExportInformation() {
      let requestData = {
        eid: this.enterpriseInfo.base.eid,
        pageIndex: this.importAndExportInformation.pageData.pageIndex,
        pageSize: this.importAndExportInformation.pageData.pageSize,
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_4723",
        requestData,
        (data) => {
          this.importAndExportInformation.tableData =
            data.entInfo.pagerEntJckxy.data;

          this.importAndExportInformation.pageData = {
            pageIndex: data.entInfo.pagerEntJckxy.pageIndex,
            pageSize: data.entInfo.pagerEntJckxy.pageSize,
            totalCount: data.entInfo.pagerEntJckxy.totalCount,
          };
          this.$emit("changeActiveCount", {
            tab2Active: "进出口信用",
            tab3Active: "",
            count: this.importAndExportInformation.pageData.totalCount,
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    /**
     * 选择页码事件
     * val:当前页
     */
    handleCurrentChange(table) {
      // 首字母转大写
      const TYPE = table.type.substr(0, 1).toUpperCase() + table.type.substr(1);
      console.log("TYPE", TYPE);
      this[table.type].pageData = table.pageData;
      this["get" + TYPE]();
      // switch (table.type) {
      //   case "ZTBInformation":
      //     this.getZTBInformation();
      //     break;
      //   case "invitePosition":
      //     this.getInvitePosition();
      //     break;
      //   case "newMediaAccount":
      //     this.getNewMediaAccount();
      //     break;
      //   default:
      //     break;
      // }
    },
  },
  mounted() {
    console.log("tabActive", this.tabActive);
    if (this.enterpriseInfo.base && this.enterpriseInfo.base.eid) {
      this.callWithDelay(
        [
          this.getZTBInformation,
          this.getInviteInformation,
          this.getInvitePosition,
          this.getNewMediaAccount,
          this.getOnlineStoreInformation,
          this.getTaxQualification,
          this.getTaxCredit,
          this.getImportAndExportInformation,
        ],
        300,
      );
    }
  },
};
</script>

<style lang="less">
#management-information {
  width: 100%;
  background-color: #fff;
  .management-information-type {
    width: 100%;
    .management-information-item {
      width: 100%;
      margin-top: 32px;
      scroll-margin-top: 180px;
      &:first-child {
        margin-top: 0;
      }
      /deep/ .el-input__inner {
        width: auto !important;
        border: 1px solid #dcdfe6;
      }
      .management-information-item-title {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
      }
      .management-information-item-tag {
        display: flex;
        margin: 12px 0;
        .tag {
          font-size: 14px;
          color: #777e95;
          cursor: pointer;
          height: 28px;
          padding: 0 12px;
          line-height: 28px;
          cursor: pointer;
          border-radius: 14px;
        }
        .is-active {
          color: #327bf9;
          background: #eaf2ff;
        }
        .is-disabled {
          color: #c3c8da;
          cursor: not-allowed;
        }
      }
      .management-information-item-value {
        width: 100%;
        .text {
          width: 100%;
          padding: 15px 23px;
          font-size: 14px;
          line-height: 24px;
          text-align: left;
          box-sizing: border-box;
          background: #f6f8fb
            url(https://51nbimg.u51.com/62c9ea111656463a90e8c968177a5d5d.png)
            right bottom / 102px 102px no-repeat;
        }
        .table-text {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          .table-text-item {
            width: 100%;
            height: 100%;
            display: flex;
            font-size: 14px;
            border: 1px solid #eff1f8;
            color: #111a34;

            .table-text-item-title {
              background-color: #f9fafc;
              width: 145px;
              min-width: 145px;
              text-align: right;
              padding: 13px 16px;
              box-sizing: border-box;
              color: #777e95;
              border-right: 1px solid #eff1f8;
            }
            .table-text-item-value {
              width: 80%;
              padding: 13px 16px;
              box-sizing: border-box;
              text-align: left;
              word-wrap: break-word;
              word-break: normal;
            }
          }
          .gather {
            .table-text-item-line {
              display: flex;
              &:last-child .table-text-item-value {
                border-bottom: 0;
              }
              .table-text-item-value {
                border-right: 1px solid #eff1f8;
                border-bottom: 1px solid #eff1f8;
                &:nth-child(even) {
                  border-right: 0;
                }
              }
            }
          }
        }
        .tab-card {
          .tab-list {
            .enterprise-card2-search {
              width: 100%;
              display: flex;
              justify-content: space-between;
              margin: 12px 0;
            }
            .enterprise-card2-content {
            }
          }
        }
      }
    }
  }
}
</style>
